import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44bb8194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-list" }

import { onMounted, reactive } from 'vue';
import teacherIcon from '@/assets/icons/emojis/teacher.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import calendarIcon from '@/assets/icons/emojis/calendar.png';
import { INotificationsFromTeachersResponseModel } from './notifications-from-teachers.types';
import getNotificationPage from './api-methods';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsFromTeachersSubpage',
  setup(__props) {

const state = reactive<{ data: INotificationsFromTeachersResponseModel }>({
    data: {} as INotificationsFromTeachersResponseModel,
});

onMounted(() => {
    const version = localStorage.getItem('studentNotificationsVersion');
    const notifications = localStorage.getItem('studentNotificationsVersion');
    notifications && version
        ? getNotificationPage('qwerty', state)
        : getNotificationPage('qwerty', state);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.notifications, (notification) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        props: {
                content: notification.notificationText,
                type: 'outlined',
                dataTags: [
                    {
                        title:
                            'Отправитель: ' +
                            notification.notificationAuthorSurenameAndInitials,
                        iconCompleteUrl: _unref(teacherIcon),
                        color: '',
                    },
                    {
                        title:
                            'Получатель: ' + notification.notificationReciever,
                        iconCompleteUrl: _unref(studentIcon),
                        color: '',
                    },
                    {
                        title:
                            'Дата отправления: ' +
                            _unref(moment)(notification.date).format('DD.MM.YYYY'),
                        iconCompleteUrl: _unref(calendarIcon),
                        color: '',
                    },
                ],
            },
        key: notification.notificationId
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})